import { render, staticRenderFns } from "./TabApoderados.vue?vue&type=template&id=04972799&scoped=true"
import script from "./TabApoderados.vue?vue&type=script&lang=js"
export * from "./TabApoderados.vue?vue&type=script&lang=js"
import style0 from "./TabApoderados.vue?vue&type=style&index=0&id=04972799&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04972799",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04972799')) {
      api.createRecord('04972799', component.options)
    } else {
      api.reload('04972799', component.options)
    }
    module.hot.accept("./TabApoderados.vue?vue&type=template&id=04972799&scoped=true", function () {
      api.rerender('04972799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabApoderados.vue"
export default component.exports